import { ManifestContextAPI } from '@wix/editor-platform-manifest-services';
import { ManifestProcessingStrategy } from '../../types';

export const getBaseManifestProcessingStrategy = async (
  rootContext: ManifestContextAPI,
): Promise<ManifestProcessingStrategy> => {
  const stylesValuesPromises: Promise<Record<string, unknown>>[] = [];

  const processStyles = (context: ManifestContextAPI) => {
    stylesValuesPromises.push(context.query.getStyles());
    context.getChildren().forEach((child) => processStyles(child));
  };

  processStyles(rootContext);

  const stylesValues = (await Promise.all(stylesValuesPromises))
    .map(Object.values)
    .flat();

  return ManifestProcessingStrategy.Recursive;

  // TODO: remove comment after selection implementation
  // return stylesValues.length
  //   ? ManifestProcessingStrategy.Recursive
  //   : ManifestProcessingStrategy.Root;
};
